var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94745 3.1965L3.78995 9.714C3.55745 9.9615 3.33245 10.449 3.28745 10.7865L3.00995 13.2165C2.91245 14.094 3.54245 14.694 4.41245 14.544L6.82745 14.1315C7.16495 14.0715 7.63745 13.824 7.86995 13.569L14.0275 7.0515C15.0925 5.9265 15.5725 4.644 13.915 3.0765C12.265 1.524 11.0125 2.0715 9.94745 3.1965Z",
    stroke: "#8493B2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91406 4.28906C9.23656 6.35906 10.9166 7.94156 13.0016 8.15156",
    stroke: "#8493B2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 17H15.75",
    stroke: "#8493B2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenameIcon);
export default __webpack_public_path__ + "static/media/renameIcon.54769a104828744e184118b00606debc.svg";
export { ForwardRef as ReactComponent };